import React from 'react';
import { Messaging, APP_FEATURES, EmergencyAssistance } from '@teladoc/inbox';
import { authToken } from '@td/api';

import '@teladoc/inbox/dist/index.css';

const stringToBool = value => value === 'true';

const Inbox = ({ containerId, emergencyAssistance }) => {
  const container = document.getElementById(containerId || 'active_conversations_container');
  const chatbox = container.getAttribute('data-chatbox');
  const participantId = parseInt(container.getAttribute('data-participant-id'));
  const participantType =  container.getAttribute('data-participant-type');
  const availableSpecialties = JSON.parse(
    container.getAttribute('data-available-specialities')
  ) || [];
  const customerServiceRoomId = container.getAttribute('data-room-id');
  const participantRole = container.getAttribute('data-participant-role');
  const hideMrLink = stringToBool(container.getAttribute('data-hide-mr-link'));
  const readOnly = stringToBool(container.getAttribute('data-read-only'));
  const locale = container.getAttribute('data-locale') || 'en';
  const headers = { Authorization: authToken.get() };
  const messageFolders = container.getAttribute('data-folders-available') === 'true';
  const customerServiceRoomFeatures = customerServiceRoomId ? {
    [APP_FEATURES.footer]:         !readOnly,
    [APP_FEATURES.footerActions]:  false,
    [APP_FEATURES.memberDetails]:  true,
    [APP_FEATURES.priorityToggle]: false
  } : {};
  const features = {
    [APP_FEATURES.messageFolders]: messageFolders,
    [APP_FEATURES.priorityToggle]: true,
    ...customerServiceRoomFeatures
  };
  const location = container.getAttribute('data-location');

  const props = {
    participantId,
    participantType,
    participantRole,
    preselectedMessageRoomId: customerServiceRoomId,
    hostUrl:                  window.SCREENFLOW_HOST,
    pubnubEnabled:            window.FEATURE_TOGGLES.pubnub_live_chat,
    pubnubSubscribeKey:       window.PUBNUB_SUBSCRIBE_KEY,
    apolloHeaders:            window.TELADOC_ENVELOP,
    headers,
    withCredentials:          true,
    features,
    availableSpecialties,
    hideMrLink,
    chatbox,
    locale,
    location
  };

  if (emergencyAssistance) {
    const logEnabled = stringToBool(container.getAttribute('data-msg-web-logs-911'));
    const emotionalRiskEnabled = stringToBool(container.getAttribute('data-emotional-risk'));
    const patientRiskEnabled = stringToBool(container.getAttribute('data-patient-risk'));
    const memberId = parseInt(container.getAttribute('data-member-id'));
    const isEmergencyEnabled = window.FEATURE_TOGGLES.prisk_new_911_emergency;
    const emergencyAssistanceFeatures = {
      ...features,
      [APP_FEATURES.priorityToggle]: false
    };

    if (!isEmergencyEnabled) return null;

    return (<EmergencyAssistance
      {...props}
      countryCd={window.LOCATION}
      emotionalRiskEnabled={emotionalRiskEnabled}
      patientRiskEnabled={patientRiskEnabled}
      logEnabled={logEnabled}
      emergencyObjectId={memberId}
      features={emergencyAssistanceFeatures}
      emergencyObjectType="Member"
      enableCloseChatBox
      chatbox
    />);
  }

  return (
    <Messaging {...props} />
  );
};

export default Inbox;
